import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import StripeContext from './components/Store/Utils/StripeContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { createAppTheme } from './theme';
import queryClient from './queryClient'; // Import the query client
import './index.css';

// Component that provides Material-UI theme based on current theme context
const DynamicMuiThemeProvider = ({ children }) => {
  const { isDarkMode } = useTheme();
  const muiTheme = createAppTheme(isDarkMode);
  
  return (
    <MuiThemeProvider theme={muiTheme}>
      {children}
    </MuiThemeProvider>
  );
};

// Component to handle dynamic Material-UI theme
const AppWithDynamicTheme = () => {
  return (
    <ThemeProvider>
      <DynamicMuiThemeProvider>
        <StripeContext>
          <CssBaseline />
          <App />
        </StripeContext>
      </DynamicMuiThemeProvider>
    </ThemeProvider>
  );
};

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <AppWithDynamicTheme />
  </QueryClientProvider>,
  document.getElementById('root')
);
